module.exports = __webpack_public_path__ + "din.0a82b71f840cb0b2f57b.ttf";


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/css/fonts/din.ttf
// module id = ../../../../../src/app/themes/default/css/fonts/din.ttf
// module chunks = 1